import React, { useEffect, useState, useMemo} from 'react';
import { LearnersOverviewProps } from './LearnersOverview.props';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { TabsHeader } from '../../components/TabsHeader';
import { OnBoardingOverview } from '../OnBoardingOverview';
import './LearnersOverview.css';
import './styles/mobile.css';
import { MobileTabs, MobileTabsProps } from '../../components/TabsHeader/components/MobileTabs';
import { CourseResultsOverview } from '../CourseResultsOverview';
import { EmailBehaviourReport } from '../EmailBehaviourReport';
import { PhishFitScore } from '../PhishFitScore';
import {useAppSelector} from "../../redux/hooks";
import {getStatusLearner, learnersDataSelector} from "../../redux/learnersSlice";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {TAB_HEADER_TITLE} from "../../constants/constants";
import ChangeWorkSpace from "../../hoc/changeWorkSpace";

// Display and landing priority for Manager XP tabs.
const TAB_PRIORITY = [
  TAB_HEADER_TITLE.COURSE_RESULTES,
  TAB_HEADER_TITLE.PHISH_FIT_SCORE,
  TAB_HEADER_TITLE.EMAIL_BEHAVIOUR_REPORT,
  TAB_HEADER_TITLE.POLICY_ACCEPTANCE,
];

const LearnersOverviewComponent: React.FC<LearnersOverviewProps> = ({tabIndex, setSubTabIndex, workSpaceCurrentData}) => {
  const dispatch = useDispatch()<any>;
  const [onBoardingNumber, setOnBoardingNumber] = useState(0)
  const[courseResultNumber, setCourseResultNumber] = useState(0);
  const {statusOverview}= useAppSelector(learnersDataSelector)
  const navigate = useNavigate()

  // Get team settings from workspace data
  const teamSetting = workSpaceCurrentData?.team_setting;
  const isTeamSettingEnabled = teamSetting?.status === 1;

  // Determine tab visibility based on team settings status only
  const showTrainingDisclosure = isTeamSettingEnabled && teamSetting?.training_disclosure?.status === 1;
  const showCourseResults = isTeamSettingEnabled && teamSetting?.course_results?.status === 1;
  const showEmailBehaviourReport = isTeamSettingEnabled && teamSetting?.email_behaviour_report?.status === 1;
  const showPhishFitScore = isTeamSettingEnabled && teamSetting?.phishfit_score?.status === 1;

  useEffect(() => {
    dispatch(getStatusLearner());
  },[dispatch]);

  useEffect(() => {
    setOnBoardingNumber(statusOverview.on_boarding);
  }, [statusOverview]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'));

  // Build tabs array based on visibility settings
  const learnerOverviewTabs = useMemo(() => {
    const tabs = [];
    if (showCourseResults) {
      tabs.push({ label: TAB_HEADER_TITLE.COURSE_RESULTES, component: <CourseResultsOverview setCourseResultNumber={setCourseResultNumber} workSpaceCurrentData={workSpaceCurrentData}/>, number: courseResultNumber });
    }
    if (showPhishFitScore) {
      tabs.push({ label: TAB_HEADER_TITLE.PHISH_FIT_SCORE, component: <PhishFitScore workSpaceCurrentData={workSpaceCurrentData} /> });
    }
    if (showEmailBehaviourReport) {
      tabs.push({ label: TAB_HEADER_TITLE.EMAIL_BEHAVIOUR_REPORT, component: <EmailBehaviourReport workSpaceCurrentData={workSpaceCurrentData} /> });
    }
    if (showTrainingDisclosure) {
      tabs.push({ label: TAB_HEADER_TITLE.POLICY_ACCEPTANCE, component: <OnBoardingOverview setOnBoardingNumber={setOnBoardingNumber} />, number: onBoardingNumber });
    }
    return tabs;
  }, [showTrainingDisclosure, showCourseResults, showEmailBehaviourReport, showPhishFitScore, onBoardingNumber, courseResultNumber, workSpaceCurrentData]);

  const defaultSubTabIndex = useMemo(() => {
    for (const label of TAB_PRIORITY) {
      const idx = learnerOverviewTabs.findIndex(t => t.label === label);
      if (idx !== -1) return idx;
    }
    return 0;
  }, [learnerOverviewTabs]);

  // Initialize header title based on priority default tab
  const [headerTitle, setHeaderTitle] = useState(() => {
    return learnerOverviewTabs[defaultSubTabIndex]?.label || TAB_HEADER_TITLE.POLICY_ACCEPTANCE;
  });

  const handleChangeTabs = (val: number) => {
    const GET_STATUS_LEARNER_TABS = [TAB_HEADER_TITLE.POLICY_ACCEPTANCE, TAB_HEADER_TITLE.COURSE_RESULTES]
    if (GET_STATUS_LEARNER_TABS.includes(learnerOverviewTabs[val].label)) {
      dispatch(getStatusLearner());
    }
    setHeaderTitle(learnerOverviewTabs[val].label);
    setSubTabIndex && setSubTabIndex(val);
    navigate("/team", {
      replace: true,
      state: {
        tabIndex: tabIndex,
        subTabIndex: val
      }
    });
  };

  return (
    <>
      {!isMobile && <h2 className={'tab-header-title'}>{(headerTitle === TAB_HEADER_TITLE.POLICY_ACCEPTANCE ? 'Training Disclosure Acceptance' : headerTitle)}</h2>}
      <Box className={'box-learners-overview'}>
        <TabsHeader
          className="learners-overview-tabs-header"
          data={learnerOverviewTabs}
          defaultValue={defaultSubTabIndex}
          onChange={handleChangeTabs}
          renderTabs={isMobile ? (props: MobileTabsProps) => <MobileTabs {...props} /> : undefined}
        />
      </Box>
    </>
  );
};
export const LearnersOverview = ChangeWorkSpace(LearnersOverviewComponent);
